const GUIDE_SLUGS = {
  home: "",
  server: "servidor",
  "server-architecture": "visao-geral",
  "server-hosting": "ambientes-hospedagem",
  "server-runtime": "modelo-por-evento",
  "server-database": "banco-dados",
  "server-communication": "http-api-websocket",
  "server-session": "sessao-seguranca",
  "server-limits": "limitacoes",
  "server-logs": "logs-auditoria",
  "server-diagnosis": "disponibilidade-diagnostico",
  "event-management": "gestao-evento",
  "event-product": "visao-comercial",
  "event-structure": "criacao-estrutura",
  "event-availability": "disponibilidade",
  "event-registration": "inscricoes",
  "event-import": "importacao",
  "event-access": "login-acessos",
  "event-users": "perfis-participantes",
  "event-emails": "emails",
  "event-reports": "relatorios",
  "event-maintenance": "manutencao",
  "event-problems": "problemas-frequentes",
  customization: "customizacao",
  "customization-system": "como-funciona",
  "customization-identity": "identidade-visual",
  "customization-modes": "modos",
  "customization-layout": "layout",
  "customization-pwa": "pwa-metatags",
  "customization-home": "pagina-inicial",
  "customization-navigation": "navegacao-componentes",
  "customization-onboarding": "login-onboarding",
  "customization-credentialing": "credenciamento",
  "customization-register": "registro-publico",
  "customization-practices": "recomendacoes-visuais",
  modules: "modulos",
  "modules-overview": "visao-geral",
  networking: "networking",
  "networking-product": "visao-produto",
  "networking-access": "ativacao-acesso",
  "networking-users": "tipos-usuario",
  "networking-navigation": "navegacao",
  "networking-components": "componentes",
  "networking-manager": "area-gestor",
  "networking-exhibitor": "area-expositor",
  "networking-pwa": "pwa-conectividade",
  "networking-analytics": "analytics",
  "component-home": "pagina-inicial",
  "component-schedule": "agenda",
  "component-streaming": "transmissoes",
  "component-speakers": "palestrantes",
  "component-exhibitors": "expositores",
  "component-sponsors": "patrocinadores",
  "component-participants": "participantes",
  "component-qrcode": "codigo-qr",
  "component-leads": "coleta-leads",
  "component-ranking": "ranking-conquistas",
  "component-activities": "atividades",
  "component-social": "social",
  "component-gallery": "galeria",
  "component-poi": "pontos-interesse",
  "component-communications": "comunicados-notificacoes",
  "component-restaurant": "alimentacao-bebidas",
  "component-custom-pages": "paginas-personalizadas",
  credentialing: "credenciamento",
  "credentialing-product": "visao-produto",
  "credentialing-connection": "conexao-evento",
  "credentialing-access": "ativacao-acesso",
  "credentialing-pages": "paginas",
  "credentialing-checkin": "check-in",
  "credentialing-registration": "registro-local",
  "credentialing-print": "impressao",
  "credentialing-local": "configuracoes-locais",
  "credentialing-rfid": "rfid",
  "credentialing-reports": "dashboards-relatorios",
  "credentialing-limitations": "conectividade-limitacoes",
  sympla: "sympla",
  "sympla-product": "visao-integracao",
  "sympla-setup": "configuracao",
  "sympla-mapping": "mapeamento-dados",
  "sympla-sync": "sincronizacao",
  "sympla-networking": "uso-networking",
  "sympla-credentialing": "uso-credenciamento",
  "sympla-rules": "regras-cuidados",
  operations: "operacao-resultados",
  "operations-preparation": "preparacao",
  "operations-publish": "publicacao",
  "operations-day": "operacao-dia",
  "operations-monitoring": "monitoramento",
  "operations-incidents": "incidentes-suporte",
  "operations-closing": "encerramento",
  "operations-analytics": "analytics-interpretacao",
  "operations-destructive": "resets-exclusoes",
  "legacy-guide": "guia-antigo",
};

const GUIDE_LAYOUT_OVERRIDES = {
  "server-architecture": "showcase",
  "server-limits": "troubleshooting",
  "server-diagnosis": "troubleshooting",
  "event-product": "showcase",
  "event-access": "comparison",
  "event-users": "comparison",
  "event-reports": "dashboard",
  "event-problems": "troubleshooting",
  "customization-modes": "comparison",
  "networking-users": "comparison",
  "networking-analytics": "dashboard",
  "credentialing-reports": "dashboard",
  "credentialing-limitations": "troubleshooting",
  "sympla-rules": "troubleshooting",
  "operations-monitoring": "dashboard",
  "operations-incidents": "troubleshooting",
  "operations-analytics": "dashboard",
  "operations-destructive": "troubleshooting",
};

const page = (id, title, description, sections = [], options = {}) => ({
  id,
  title,
  description,
  sections,
  kind: "article",
  slug: GUIDE_SLUGS[id],
  searchable: true,
  ...options,
});

const hub = (id, title, description, children, options = {}) => ({
  id,
  title,
  description,
  children,
  sections: [],
  kind: "hub",
  slug: GUIDE_SLUGS[id],
  searchable: true,
  ...options,
});
export const PLATFORM02_NOTIFICATION_GUIDE_SECTIONS = Object.freeze([
  "Visão geral",
  "Como funciona",
  "Ativação, permissão e opt-out",
  "Compatibilidade por dispositivo",
  "Catálogo",
  "Entrega, histórico e limites",
  "Boas práticas e diagnóstico",
]);

export const PLATFORM02_NOTIFICATION_FLOW = Object.freeze([
  {
    title: "Acontecimento",
    description: "Uma ação confirmada, um lembrete agendado ou uma mensagem administrativa inicia o fluxo.",
  },
  {
    title: "Caixa de notificações",
    description: "O servidor grava um item durável, aplica a identidade da origem e atualiza o contador do participante.",
  },
  {
    title: "Fila por dispositivo",
    description: "Quando o tipo aceita Web Push, o servidor cria um trabalho para cada inscrição ativa daquele participante.",
  },
  {
    title: "Navegador e sistema",
    description: "O provedor entrega ao service worker, que solicita ao sistema operacional a exibição do aviso.",
  },
  {
    title: "Abertura e destino",
    description: "O clique abre o destino relacionado, registra a abertura e sincroniza os estados de visualização e leitura.",
  },
]);

export const PLATFORM02_NOTIFICATION_DEVICE_COMPATIBILITY = Object.freeze([
  {
    id: "desktop",
    device: "Computadores",
    available: true,
    summary: "Chrome, Edge e Firefox atuais em Windows, macOS ou Linux; Safari atual no macOS.",
    requirements: "HTTPS, service worker ativo e permissão concedida pelo usuário.",
  },
  {
    id: "android",
    device: "Android",
    available: true,
    summary: "Navegadores modernos com Push API, como Chrome, Edge e Firefox.",
    requirements: "Economia de bateria, restrições do fabricante ou limpeza de dados podem atrasar ou revogar a inscrição.",
  },
  {
    id: "ios",
    device: "iPhone e iPad",
    available: true,
    summary: "iOS/iPadOS 16.4 ou superior, somente para o aplicativo adicionado à Tela de Início.",
    requirements: "O pedido de permissão precisa partir de uma ação direta dentro do PWA instalado.",
  },
  {
    id: "embedded",
    device: "Navegador interno e WebView",
    available: false,
    summary: "Aberturas dentro de Instagram, Facebook, Teams, leitores de QR ou outros aplicativos não são confiáveis para Web Push.",
    requirements: "Oriente a abertura em um navegador compatível e, no iPhone/iPad, a instalação na Tela de Início.",
  },
  {
    id: "private",
    device: "Modo privado ou temporário",
    available: false,
    summary: "O suporte varia e a inscrição pode desaparecer ao encerrar a sessão.",
    requirements: "Use uma janela normal para o teste operacional e para a experiência definitiva.",
  },
]);

export const PLATFORM02_IMPORT_GUIDE_SECTIONS = Object.freeze([
  "Como funciona",
  "Formato e modelo",
  "Validações por linha",
  "Modo de emergência",
  "Erros e correções",
  "Capacidade e transação",
  "Checklist",
]);

export const PLATFORM02_IMPORT_FIELD_RULES = Object.freeze([
  {
    id: "required",
    label: "Obrigatório e primário",
    normal: "Campos obrigatórios e campos marcados como identificação precisam ter valor.",
    emergency: "A validação local é ignorada; o servidor continua validando a estrutura e os conflitos.",
    fix: "Preencha o campo na planilha e confirme se o cabeçalho corresponde ao título do formulário.",
  },
  {
    id: "text",
    label: "Texto curto",
    normal: "Texto de até 255 caracteres.",
    emergency: "Não é conferido pelo navegador; revise manualmente antes de usar a emergência.",
    fix: "Remova o excesso de caracteres e mantenha texto simples na célula.",
  },
  {
    id: "textBig",
    label: "Texto longo",
    normal: "Texto de até 2.500 caracteres.",
    emergency: "Não é conferido pelo navegador; revise manualmente antes de usar a emergência.",
    fix: "Reduza o conteúdo para, no máximo, 2.500 caracteres.",
  },
  {
    id: "email",
    label: "E-mail e domínio",
    normal: "Formato de e-mail, limite de 255 caracteres e, quando configurado, domínio permitido.",
    emergency: "A coluna email da Plataforma 2 continua validada no navegador e no servidor; e-mails em campos comuns deixam de passar pela checagem Yup local.",
    fix: "Use usuario@dominio.com e, se houver restrição, um domínio listado na configuração do evento.",
  },
  {
    id: "cpf",
    label: "CPF",
    normal: "CPF preenchido deve passar na validação dos dígitos; campos primários também são únicos.",
    emergency: "A conferência de CPF pelo navegador é ignorada; a unicidade do campo, quando primário, continua no servidor.",
    fix: "Informe um CPF real no formato aceito e corrija valores repetidos.",
  },
  {
    id: "cnpj",
    label: "CNPJ",
    normal: "CNPJ preenchido deve passar na validação dos dígitos; campos primários também são únicos.",
    emergency: "A conferência de CNPJ pelo navegador é ignorada; a unicidade do campo, quando primário, continua no servidor.",
    fix: "Informe um CNPJ real e corrija valores repetidos.",
  },
  {
    id: "telefone",
    label: "Telefone",
    normal: "Telefone obrigatório precisa conter mais de 9 dígitos numéricos; o campo aceita até 255 caracteres.",
    emergency: "A conferência de formato pelo navegador é ignorada.",
    fix: "Use DDD e número completos e remova texto que não faça parte do telefone.",
  },
  {
    id: "date",
    label: "Data",
    normal: "Data válida em DD/MM/AAAA ou DD/MM/AAAA HH:mm; campos obrigatórios não podem ficar vazios.",
    emergency: "A conferência de formato pelo navegador é ignorada.",
    fix: "Corrija dia, mês, ano e horário para um formato reconhecido.",
  },
  {
    id: "number",
    label: "Número",
    normal: "Aceita somente números e até 255 caracteres quando convertido para texto.",
    emergency: "A conferência de formato pelo navegador é ignorada.",
    fix: "Remova símbolos e texto; use apenas o valor numérico esperado.",
  },
  {
    id: "choice",
    label: "Seleção única",
    normal: "O valor precisa ser uma das opções configuradas no formulário.",
    emergency: "A conferência local da opção é ignorada; opções controladas por vagas continuam bloqueadas no servidor.",
    fix: "Copie a opção exatamente como aparece no formulário ou gere um novo modelo.",
  },
  {
    id: "multi-choice",
    label: "Seleção múltipla",
    normal: "A célula deve conter uma lista de opções válidas e respeitar os limites mínimo e máximo.",
    emergency: "A conferência local da lista e dos limites é ignorada; vagas e integridade continuam no servidor.",
    fix: "Use as opções permitidas, sem duplicá-las, e respeite o mínimo/máximo indicado no formulário.",
  },
  {
    id: "dependency",
    label: "Dependências e visibilidade",
    normal: "Campos dependentes só são validados quando a opção-pai os torna visíveis; campos ocultos não são importáveis.",
    emergency: "A decisão de visibilidade e a remoção de campos ocultos continuam sendo aplicadas.",
    fix: "Preencha somente campos visíveis para a combinação escolhida e revise a opção-pai.",
  },
  {
    id: "header",
    label: "Cabeçalhos",
    normal: "Todos os títulos precisam ser únicos, conhecidos e conter os campos obrigatórios; a Plataforma 2 exige email.",
    emergency: "A estrutura do arquivo nunca é ignorada.",
    fix: "Baixe o modelo atualizado, mantenha uma única linha de cabeçalho e remova/renomeie colunas inválidas.",
  },
  {
    id: "duplicates",
    label: "Duplicidade",
    normal: "E-mail e valores de identificação primários são verificados dentro do arquivo e contra o evento.",
    emergency: "A checagem local pode ser ignorada no navegador, mas o servidor continua bloqueando duplicidades.",
    fix: "Deixe cada valor único e remova pessoas já cadastradas no evento.",
  },
  {
    id: "vacancy",
    label: "Vagas por opção",
    normal: "Cada seleção controlada precisa existir na configuração e ter vagas disponíveis considerando todas as linhas.",
    emergency: "Nunca é ignorada; a disponibilidade é conferida no servidor com bloqueio de concorrência.",
    fix: "Escolha uma opção com saldo, aumente a capacidade ou importe em outro lote.",
  },
  {
    id: "limit",
    label: "Limite total de inscrições",
    normal: "O lote projetado não pode ultrapassar o limite configurado para o evento.",
    emergency: "Nunca é ignorado pelo servidor.",
    fix: "Aumente o limite ou reduza a quantidade de linhas do arquivo.",
  },
]);

export const PLATFORM02_IMPORT_VALIDATION_GUIDE = Object.freeze([
  { code: "FILE_MISSING", category: "Arquivo", label: "Arquivo não selecionado", when: "Nenhum arquivo foi escolhido.", fix: "Selecione um arquivo .xlsx, .xls ou .csv." },
  { code: "FILE_TOO_LARGE", category: "Arquivo", label: "Arquivo maior que 10 MB", when: "O arquivo excede o limite de upload.", fix: "Remova colunas/linhas desnecessárias ou divida o lote." },
  { code: "FILE_TYPE", category: "Arquivo", label: "Formato não suportado", when: "A extensão não é aceita.", fix: "Salve como .xlsx, .xls ou .csv." },
  { code: "FILE_READ", category: "Arquivo", label: "Falha de leitura", when: "O navegador não consegue abrir o arquivo.", fix: "Feche o arquivo em outro programa e exporte-o novamente." },
  { code: "FILE_PARSE", category: "Arquivo", label: "Conteúdo ilegível", when: "O conteúdo não corresponde a uma planilha válida.", fix: "Exporte novamente como .xlsx, .xls ou .csv." },
  { code: "MULTIPLE_SHEETS", category: "Arquivo", label: "Mais de uma planilha", when: "O arquivo possui duas ou mais abas.", fix: "Mantenha somente uma aba com os dados." },
  { code: "EMPTY_FILE", category: "Arquivo", label: "Arquivo sem cabeçalho", when: "Não existe uma primeira linha de títulos.", fix: "Inclua os cabeçalhos na primeira linha." },
  { code: "EMPTY_HEADER", category: "Cabeçalhos e formulário", label: "Cabeçalho vazio", when: "Uma coluna não tem título.", fix: "Preencha o título ou remova a coluna." },
  { code: "DUPLICATE_HEADER", category: "Cabeçalhos e formulário", label: "Cabeçalho repetido", when: "O mesmo título aparece mais de uma vez.", fix: "Renomeie ou remova uma das colunas." },
  { code: "UNKNOWN_HEADER", category: "Cabeçalhos e formulário", label: "Cabeçalho desconhecido", when: "O título não pertence ao formulário atual.", fix: "Use o modelo do evento e remova colunas extras." },
  { code: "MISSING_EMAIL_HEADER", category: "Cabeçalhos e formulário", label: "Coluna email ausente", when: "A Plataforma 2 não encontrou o cabeçalho reservado email.", fix: "Inclua uma única coluna chamada email." },
  { code: "MISSING_REQUIRED_HEADER", category: "Cabeçalhos e formulário", label: "Cabeçalho obrigatório ausente", when: "Um campo obrigatório/primário não está na primeira linha.", fix: "Adicione o título exatamente como está no formulário." },
  { code: "AMBIGUOUS_EMAIL_HEADER", category: "Cabeçalhos e formulário", label: "Título email ambíguo", when: "Um campo do formulário usa email, título reservado na Plataforma 2.", fix: "Renomeie o campo do formulário e gere o modelo novamente." },
  { code: "DUPLICATE_FORM_LABEL", category: "Cabeçalhos e formulário", label: "Títulos do formulário repetidos", when: "Dois campos têm o mesmo título e não podem ser mapeados com segurança.", fix: "Renomeie um dos campos antes de importar." },
  { code: "FIELD_VALIDATION", category: "Conteúdo do campo", label: "Valor fora da regra", when: "Uma regra Yup do campo falhou no navegador (obrigatório, formato, opção ou limite).", fix: "Consulte o campo e a regra na seção Validações por linha e corrija a célula." },
  { code: "INVALID_EMAIL", category: "E-mail", label: "E-mail inválido", when: "A coluna email está vazia ou fora do formato.", fix: "Informe um e-mail único no formato usuario@dominio.com." },
  { code: "EMAIL_DOMAIN_NOT_ALLOWED", category: "E-mail", label: "Domínio não permitido", when: "O domínio não está na lista autorizada do evento.", fix: "Use um domínio permitido ou ajuste a configuração do evento." },
  { code: "DUPLICATE_EMAIL_IN_FILE", category: "Duplicidade", label: "E-mail repetido no arquivo", when: "Duas ou mais linhas usam o mesmo e-mail.", fix: "Mantenha uma linha por e-mail." },
  { code: "DUPLICATE_EMAIL", category: "Duplicidade", label: "E-mail já cadastrado", when: "O e-mail já pertence a um participante do evento.", fix: "Remova a linha ou use a edição do participante existente." },
  { code: "DUPLICATE_PRIMARY_IN_FILE", category: "Duplicidade", label: "Identificação repetida no arquivo", when: "Um valor de campo primário aparece em mais de uma linha.", fix: "Corrija o valor ou mantenha somente uma linha." },
  { code: "DUPLICATE_PRIMARY", category: "Duplicidade", label: "Identificação já cadastrada", when: "O valor de campo primário já existe no evento.", fix: "Use um valor único ou edite o cadastro existente." },
  { code: "INVALID_FORM_FIELD_VACANCY", category: "Vagas por opção", label: "Configuração de vaga inválida", when: "A opção selecionada não tem configuração de vagas correspondente.", fix: "Configure a vaga para todas as opções ou escolha uma opção configurada." },
  { code: "FORM_FIELD_VACANCY_EXHAUSTED", category: "Vagas por opção", label: "Vaga esgotada", when: "O saldo da opção termina durante a avaliação do lote.", fix: "Aumente as vagas, escolha outra opção ou reduza o lote." },
  { code: "INVALID_SUBSCRIPTION_LIMIT", category: "Limite de inscrições", label: "Limite de inscrições inválido", when: "O limite não é inteiro positivo ou ficou menor que a base existente.", fix: "Corrija o limite no evento e salve a configuração antes de importar." },
  { code: "SUBSCRIPTION_LIMIT_EXHAUSTED", category: "Limite de inscrições", label: "Limite total atingido", when: "O lote ultrapassa o limite total do evento.", fix: "Aumente o limite ou reduza as linhas importadas." },
  { code: "IMPORT_REQUEST_INVALID", category: "Validação do servidor", label: "Solicitação de importação inválida", when: "O pedido enviado não contém os dados esperados.", fix: "Recarregue o evento, selecione o arquivo novamente e tente salvar." },
  { code: "IMPORT_EVENT_JSON_INVALID", category: "Validação do servidor", label: "Configuração do evento inválida", when: "O servidor não consegue interpretar o JSON atual do evento.", fix: "Atualize a página, corrija a configuração e tente novamente." },
  { code: "IMPORT_ROWS_INVALID", category: "Validação do servidor", label: "Lista de linhas inválida", when: "Os participantes não foram enviados como uma lista.", fix: "Selecione o arquivo novamente; não edite o payload manualmente." },
  { code: "IMPORT_ROW_INVALID", category: "Validação do servidor", label: "Linha com formato inválido", when: "Uma linha não é um registro de participante válido.", fix: "Remova a linha corrompida e gere o modelo novamente." },
  { code: "IMPORT_RELATED_PARTICIPANT_INVALID", category: "Validação do servidor", label: "Participante relacionado inválido", when: "Um registro adicional contém e-mail inválido.", fix: "Corrija o e-mail do registro relacionado." },
  { code: "IMPORT_PREFLIGHT_FAILED", category: "Validação do servidor", label: "Falha na pré-validação", when: "O servidor não concluiu a checagem antes do salvamento.", fix: "Tente novamente; se persistir, aguarde a API e confira os logs de suporte." },
  { code: "IMPORT_VALIDATION_FAILED", category: "Validação do servidor", label: "Importação bloqueada", when: "Uma ou mais regras impediram o lote.", fix: "Abra o relatório, filtre por linha/categoria e corrija todos os itens." },
  { code: "EVENT_UPDATE_FAILED", category: "Validação do servidor", label: "Falha ao salvar evento", when: "O evento não pôde ser atualizado depois da importação.", fix: "Tente novamente; nenhum lote parcial deve ser considerado salvo." },
]);

export const PLATFORM02_NOTIFICATION_CATALOG = Object.freeze([
  {
    type: "admin_notification",
    category: "Operação",
    title: "Aviso administrativo",
    description: "Aviso geral ou segmentado criado pela organização.",
    webPush: true,
  },
  {
    type: "admin_statement",
    category: "Operação",
    title: "Comunicado",
    description: "Comunicado publicado para consulta na área de comunicados.",
    webPush: true,
  },
  {
    type: "activity_available",
    category: "Atividades",
    title: "Atividade disponível",
    description: "Liberação ou chamada operacional para uma atividade.",
    webPush: true,
  },
  {
    type: "event_reminder",
    category: "Agenda",
    title: "Lembrete de agenda",
    description: "Lembrete automático para participante interessado em uma sessão.",
    webPush: true,
  },
  {
    type: "stream_starting",
    category: "Transmissões",
    title: "Transmissão prestes a começar",
    description: "Aviso programado para uma transmissão associada à agenda.",
    webPush: true,
  },
  {
    type: "stream_status_changed",
    category: "Transmissões",
    title: "Transmissão entrou ao vivo",
    description: "Confirmação de que a transmissão de interesse começou.",
    webPush: true,
  },
  {
    type: "friend_request_receive",
    category: "Networking",
    title: "Solicitação de conexão recebida",
    description: "Outro participante solicitou uma conexão.",
    webPush: true,
  },
  {
    type: "friend_request_sent",
    category: "Networking",
    title: "Solicitação de conexão aceita",
    description: "O participante de destino aceitou a conexão pendente.",
    webPush: true,
  },
  {
    type: "chat_invite_receive",
    category: "Chat",
    title: "Convite para conversa recebido",
    description: "Convite para iniciar uma conversa direta.",
    webPush: true,
  },
  {
    type: "chat_invite_accepted",
    category: "Chat",
    title: "Convite para conversa aceito",
    description: "Confirmação de aceite do convite de conversa.",
    webPush: true,
  },
  {
    type: "qrcode_contact_added",
    category: "Código QR",
    title: "Contato adicionado por QR",
    description: "Conexão registrada após a leitura do QR pessoal.",
    webPush: false,
    pushReason: "Registro na caixa; o fluxo presencial não dispara Web Push.",
  },
  {
    type: "qrcode_interest_point_added",
    category: "Código QR",
    title: "Ponto de interesse coletado",
    description: "Confirmação da coleta de um ponto de interesse.",
    webPush: false,
    pushReason: "Confirmação da própria ação no aplicativo.",
  },
  {
    type: "qrcode_exhibitor_added",
    category: "Código QR",
    title: "Expositor adicionado por QR",
    description: "Confirmação da visita ou coleta associada ao expositor.",
    webPush: false,
    pushReason: "Confirmação da própria ação no aplicativo.",
  },
  {
    type: "social_post_liked",
    category: "Social",
    title: "Publicação curtida",
    description: "Uma pessoa curtiu uma publicação de outro autor.",
    webPush: true,
  },
  {
    type: "social_post_commented",
    category: "Social",
    title: "Novo comentário na publicação",
    description: "Uma pessoa comentou uma publicação de outro autor.",
    webPush: true,
  },
  {
    type: "social_comment_mentioned",
    category: "Social",
    title: "Menção em comentário",
    description: "O participante foi marcado em um comentário.",
    webPush: true,
  },
  {
    type: "chat_message",
    category: "Chat",
    title: "Nova mensagem direta ou de grupo",
    description: "Mensagem recebida fora da conversa ativa; a caixa agrupa o histórico por conversa.",
    webPush: true,
    pushReason: "Pode ser suprimido quando a conversa está aberta ou silenciada.",
  },
  {
    type: "chat_group_message",
    category: "Chat",
    title: "Mensagem de grupo (histórico legado)",
    description: "Tipo mantido para renderizar registros criados por versões anteriores.",
    webPush: false,
    pushReason: "Não é produzido pelo fluxo atual.",
  },
  {
    type: "chat_group_added",
    category: "Chat",
    title: "Adicionado a um grupo",
    description: "Inclusão em um grupo novo ou existente.",
    webPush: true,
  },
  {
    type: "chat_group_removed",
    category: "Chat",
    title: "Removido de um grupo",
    description: "Remoção realizada por um administrador do grupo.",
    webPush: true,
  },
  {
    type: "chat_group_role_changed",
    category: "Chat",
    title: "Permissão de administrador do grupo",
    description: "Delegação da função de administrador.",
    webPush: true,
  },
  {
    type: "restaurant_order_update",
    category: "A&B",
    title: "Atualização de pedido",
    description: "Mudança de status, pedido pronto ou decisão de cancelamento.",
    webPush: true,
  },
  {
    type: "activity_photo_reviewed",
    category: "Atividades",
    title: "Resultado da moderação de foto",
    description: "Foto aprovada, rejeitada ou aprovação revertida.",
    webPush: true,
  },
  {
    type: "photo_competition_winner",
    category: "Atividades",
    title: "Vencedor de competição de fotos",
    description: "Resultado final com vitória individual ou empatada.",
    webPush: true,
  },
  {
    type: "photo_competition_reopened",
    category: "Atividades",
    title: "Competição de fotos reaberta",
    description: "O resultado anterior foi reaberto para revisão.",
    webPush: true,
  },
  {
    type: "achievement_unlocked",
    category: "Conquistas",
    title: "Conquista desbloqueada",
    description: "Conclusão permanente de uma conquista do participante.",
    webPush: true,
    pushReason: "Disponível quando a apresentação de conquistas está habilitada.",
  },
]);

const networkingComponents = hub(
  "networking-components",
  "Componentes",
  "Catálogo das experiências que podem compor o aplicativo do evento.",
  [
    page("component-home", "Página inicial", "Entrada editorial e comercial do aplicativo.", [
      "Banners",
      "Conteúdo editorial",
      "Agenda em destaque",
      "Transmissões em destaque",
      "Atividades em destaque",
      "Ordem dos blocos",
    ]),
    page("component-schedule", "Agenda", "Programação, sessões e participação do público.", [
      "Sessões",
      "Categorias",
      "Datas e horários",
      "Palestrantes associados",
      "Interesse e confirmação",
      "Sistema de vagas",
      "Arquivos e atividades",
    ]),
    page("component-streaming", "Transmissões", "Canais ao vivo ou programados dentro da agenda.", [
      "Canal e responsável",
      "Fontes e ordenação",
      "Experiência do público",
      "Chat, reações e feedback",
      "Enquetes e comunicados",
      "Moderação",
      "Relatório e resets",
    ]),
    page("component-speakers", "Palestrantes", "Perfis profissionais conectados à programação.", [
      "Lista de palestrantes",
      "Perfil e imagem",
      "Biografia",
      "Empresa ou profissão",
      "Sessões associadas",
      "Métricas",
    ]),
    page("component-exhibitors", "Expositores", "Vitrine comercial de empresas, estandes e equipes.", [
      "Lista e perfil",
      "Usuários associados",
      "Coleta de leads",
      "Visita por QR Code",
      "Dinâmicas de quiz",
      "Métricas comerciais",
    ]),
    page("component-sponsors", "Patrocinadores", "Exposição de marcas organizada por categorias ou níveis.", [
      "Categorias e níveis",
      "Lista e perfil",
      "Links",
      "Impressões",
      "Aberturas de detalhes",
      "Cliques e relatório comercial",
    ]),
    page("component-participants", "Participantes", "Diretório e jornada de relacionamento entre pessoas.", [
      "Diretório",
      "Perfil",
      "Pesquisa",
      "Solicitações e conexões",
      "Bloqueios",
      "Modo somente QR",
      "Métricas de relacionamento",
    ]),
    page("component-qrcode", "Código QR", "Ponto de encontro entre networking, presença e ativações.", [
      "QR pessoal",
      "Leitor",
      "Conexão entre participantes",
      "Visita a expositor",
      "Coleta de lead",
      "Pontos de interesse",
      "Origens e pontuação",
    ]),
    page("component-leads", "Coleta de leads", "Captação comercial para gestores e expositores.", [
      "Perfis autorizados",
      "Expositor associado",
      "Participantes registrados",
      "Participantes não registrados",
      "Formulário",
      "Exportação",
      "Métricas",
    ]),
    page("component-ranking", "Ranking e conquistas", "Configure pontos e classificação sem confundir o placar com as conquistas permanentes.", [
      "Sistema de pontuação",
      "Catálogo de pontuação",
      "Catálogo de conquistas",
      "Regras de operação",
    ]),
    page("component-activities", "Atividades", "Dinâmicas de quiz, envio de foto e competição.", [
      "Catálogo de atividades",
      "Quiz",
      "Envio de foto",
      "Competição de fotos",
      "Moderação",
      "Pontuação",
      "Histórico",
    ]),
    page("component-social", "Social", "Feed, publicações e conversas dentro do evento.", [
      "Feed",
      "Publicações e álbuns",
      "Curtidas e comentários",
      "Denúncias e moderação",
      "Conversas diretas",
      "Grupos",
      "Chat de transmissão",
    ]),
    page("component-gallery", "Galeria", "Acervo visual organizado para consulta no aplicativo.", [
      "Imagens",
      "Categorias",
      "Ordenação",
      "Visualização",
      "Gestão e limpeza",
    ]),
    page("component-poi", "Pontos de interesse", "Jornadas físicas ou virtuais ativadas por QR Code.", [
      "Pontos",
      "Mapa",
      "QR Code",
      "Coleta",
      "Disponibilidade",
      "Pontuação",
    ]),
    page("component-communications", "Comunicados e notificações", "Mensagens operacionais e lembretes para o público.", [
      "Comunicados",
      "Caixa de notificações",
      "Web Push",
      "Lembretes",
      "Histórico",
      "Destinos e deep links",
    ], { sections: PLATFORM02_NOTIFICATION_GUIDE_SECTIONS }),
    page("component-restaurant", "A&B", "Catálogo e operação de pedidos de alimentos e bebidas.", [
      "Banners",
      "Categorias",
      "Itens",
      "Mesas",
      "Pedidos",
      "Status e cancelamentos",
    ]),
    page("component-custom-pages", "Páginas personalizadas", "Conteúdo complementar e destinos externos.", [
      "Conteúdo HTML",
      "Imagens e arquivos",
      "Google Maps",
      "Links externos",
      "Menu e rodapé",
      "Página inicial",
    ]),
  ],
  { layout: "catalog" },
);

const networking = hub(
  "networking",
  "Networking",
  "Aplicativo digital do evento para conteúdo, relacionamento e engajamento.",
  [
    page("networking-product", "Visão do produto", "Proposta, aplicações e jornadas atendidas pelo Networking.", [
      "Experiência do participante",
      "Eventos presenciais e híbridos",
      "Conteúdo e relacionamento",
      "Engajamento",
      "Comunicação",
      "Resultados",
    ]),
    page("networking-access", "Ativação e acesso", "Condições que publicam e liberam o aplicativo.", [
      "Ativação do módulo",
      "Token do evento",
      "Status do evento",
      "Login e registro",
      "Convidados",
      "Sessão e primeiro acesso",
    ]),
    page("networking-users", "Tipos de usuário", "Experiências e permissões de cada perfil.", [
      "Participante",
      "Gestor",
      "Expositor",
      "Convidado",
      "Usuários pendentes e inativos",
      "Matriz de acesso",
    ]),
    page("networking-navigation", "Navegação", "Estrutura de acesso às áreas e componentes do aplicativo.", [
      "Página inicial",
      "Cabeçalho",
      "Menu",
      "Rodapé",
      "Código QR",
      "Perfil e notificações",
      "Ordem e disponibilidade das seções",
    ]),
    networkingComponents,
    page("networking-manager", "Área do gestor", "Ferramentas operacionais disponíveis no próprio aplicativo.", [
      "Dashboard",
      "Participantes",
      "Notificações",
      "Galeria",
      "A&B",
      "Atividades",
      "Agenda e transmissões",
      "Expositores",
    ]),
    page("networking-exhibitor", "Área do expositor", "Experiência da equipe comercial e do estande.", [
      "Perfil do expositor",
      "Associação ao estande",
      "Coleta de leads",
      "Código QR",
      "Exportação",
    ]),
    page("networking-pwa", "PWA e conectividade", "Instalação, cache, atualizações e limites offline.", [
      "Instalação",
      "Atualizações",
      "Cache de inicialização",
      "Páginas visitadas",
      "Recursos offline",
      "Recursos que exigem conexão",
      "Reconexão",
    ]),
    page("networking-analytics", "Analytics", "Leituras de público, conteúdo, relacionamento e negócio.", [
      "Visão geral",
      "Público",
      "Networking",
      "Conteúdo",
      "Aquisição",
      "Comunicações",
      "Comercial",
      "Navegação",
      "Qualidade dos dados",
    ]),
  ],
  { kind: "module", layout: "showcase" },
);

const credentialing = hub(
  "credentialing",
  "Credenciamento",
  "Solução de recepção, check-in, cadastro e impressão de etiquetas.",
  [
    page("credentialing-product", "Visão do produto", "Papel do Credenciamento dentro da experiência do evento.", [
      "Recepção",
      "Identificação",
      "Cadastro no local",
      "Check-in",
      "Impressão",
      "Monitoramento de presença",
    ]),
    page("credentialing-connection", "Conexão com o evento", "Dados e regras compartilhados com a Plataforma de eventos.", [
      "Evento compartilhado",
      "Base de participantes",
      "Formulário",
      "Check-ins",
      "Pontuação",
      "Sympla",
      "Identidade independente",
    ]),
    page("credentialing-access", "Ativação e acesso", "Canais utilizados pela equipe e pelo participante.", [
      "Habilitação do módulo",
      "Código da equipe",
      "Link da estação",
      "Link de registro",
      "Sessão do operador",
      "Sessão do participante",
    ]),
    page("credentialing-pages", "Páginas disponíveis", "Mapa das telas operacionais e públicas.", [
      "Login",
      "Início operacional",
      "Controle de check-in",
      "Dashboard",
      "Participantes",
      "Registro público",
      "Histórico",
      "Últimos check-ins",
      "RFID e suporte",
    ]),
    page("credentialing-checkin", "Check-in", "Formas de identificar uma pessoa e registrar sua presença.", [
      "Busca por dados",
      "Código QR",
      "RFID",
      "Código externo",
      "Cadastro no local",
      "Check-in em lote",
      "Duplicidades",
      "Origem e histórico",
    ]),
    page("credentialing-registration", "Registro no local", "Cadastro público e assistido durante o evento.", [
      "Permissão de cadastro",
      "Formulário",
      "E-mail",
      "Limite de inscrições",
      "Check-in automático",
      "Confirmação",
    ]),
    page("credentialing-print", "Impressão", "Modelos e fluxos de impressão de credenciais.", [
      "ZPL",
      "Modelos de etiqueta",
      "Variáveis",
      "QR Code",
      "Zebra Browser Print",
      "Protocolo USB",
      "Impressão individual e em lote",
      "Check-in ao imprimir",
    ]),
    page("credentialing-local", "Configurações locais", "Preferências específicas de cada estação de atendimento.", [
      "Nome da estação",
      "Tipo de impressão",
      "Modelo de etiqueta",
      "Câmera",
      "RFID",
      "Fullscreen",
      "Reset local",
    ]),
    page("credentialing-rfid", "RFID", "Associação, leitura e validação de tags.", [
      "Campo RFID",
      "Associação da tag",
      "Leitura",
      "Localização do participante",
      "Check-in",
      "Equipamentos e testes",
    ]),
    page("credentialing-reports", "Dashboards e relatórios", "Indicadores de presença e produtividade das estações.", [
      "Participantes",
      "Presentes e ausentes",
      "Evolução por horário",
      "Estações",
      "Últimos check-ins",
      "Histórico",
      "Filtros e exportação",
    ]),
    page("credentialing-limitations", "Conectividade e limitações", "Dependências técnicas que afetam a operação no local.", [
      "Operação online",
      "API HTTP",
      "Atualização periódica",
      "Câmera e navegador",
      "Software de impressão",
      "Serviços externos",
      "Contingência",
    ]),
  ],
  { kind: "module", layout: "workflow" },
);

const sympla = hub(
  "sympla",
  "Sympla",
  "Integração de participantes, acesso e check-in com a plataforma Sympla.",
  [
    page("sympla-product", "Visão da integração", "Possibilidades e fronteiras da integração.", [
      "Objetivo",
      "Quando utilizar",
      "Participantes",
      "Login",
      "Check-in",
      "Sincronização",
    ]),
    page("sympla-setup", "Configuração", "Credenciais, evento associado e estado da integração.", [
      "Token de acesso",
      "Seleção do evento",
      "Evento associado",
      "Última atualização",
      "Campos recebidos",
    ]),
    page("sympla-mapping", "Mapeamento de dados", "Relação entre campos da Sympla e do formulário R1.", [
      "Campo de origem",
      "Campo de destino",
      "Campos obrigatórios",
      "Campos únicos",
      "Compatibilidade",
      "Validação",
    ]),
    page("sympla-sync", "Sincronização", "Formas de importar e manter a base atualizada.", [
      "Consulta manual",
      "Importação inicial",
      "Sincronização automática",
      "Participantes aprovados",
      "Check-ins",
      "Atualizações e remoções",
    ]),
    page("sympla-networking", "Uso no Networking", "Entrada do participante a partir da integração.", [
      "Participante externo",
      "Código do ingresso",
      "Associação local",
      "Login",
      "Múltiplas contas",
      "E-mails",
    ]),
    page("sympla-credentialing", "Uso no Credenciamento", "Validação e presença a partir do ingresso externo.", [
      "Busca por código",
      "Participante local",
      "Check-in na Sympla",
      "Check-in local",
      "Histórico",
      "Falhas externas",
    ]),
    page("sympla-rules", "Regras e cuidados", "Decisões necessárias antes de automatizar a integração.", [
      "Evento selecionado",
      "Mapeamentos",
      "Fonte principal dos dados",
      "Exportação de segurança",
      "Remoções automáticas",
      "Proteção do token",
      "Contingência",
    ]),
  ],
  { kind: "module", layout: "workflow" },
);

const GUIDE_NAVIGATION_SOURCE = [
  page("home", "Tela inicial", "Visão comercial da solução, seus módulos e jornadas.", [], {
    kind: "home",
    layout: "showcase",
  }),
  hub("server", "Servidor e infraestrutura", "Arquitetura, segurança, disponibilidade e limites da solução.", [
    page("server-architecture", "Visão geral da arquitetura", "Mapa dos produtos, serviços e integrações.", [
      "Painel e API central",
      "Aplicativo Networking",
      "API HTTP e Socket.IO",
      "Credenciamento",
      "Imagens e arquivos",
      "Banco de dados",
    ]),
    page("server-hosting", "Ambientes e hospedagem", "Servidores, domínios, builds e processo de publicação.", [
      "Ambientes",
      "Servidores AWS",
      "Builds hospedados",
      "Domínios",
      "Publicação e rollback",
      "Dependências externas",
    ], { status: "Aguardando dados AWS" }),
    page("server-runtime", "Modelo por evento", "Como eventos, tokens e processos são relacionados.", [
      "Identificação do evento",
      "Token público",
      "Runtime dedicado",
      "Processos",
      "Serviços compartilhados",
      "Escalabilidade atual",
    ]),
    page("server-database", "Banco de dados", "Organização, isolamento e ciclo de vida dos dados.", [
      "Schema compartilhado",
      "Separação por evento",
      "Configuração do evento",
      "Domínios de dados",
      "Datas e fuso horário",
      "Backups e retenção",
    ]),
    page("server-communication", "HTTP, API e WebSocket", "Diferenças entre transações, atualização contínua e polling.", [
      "Requisições HTTP",
      "Socket.IO",
      "Credenciamento por HTTP",
      "Atualização periódica",
      "Fallbacks",
      "Perda de conexão",
    ]),
    page("server-session", "Sessão e segurança", "Tokens, cookies, armazenamento local e proteção de acesso.", [
      "Token do evento",
      "Cookie JWT",
      "Sessões",
      "LocalStorage",
      "HTTPS e CORS",
      "API keys e integrações",
      "LGPD",
    ]),
    page("server-limits", "Limitações atuais", "Fronteiras técnicas relevantes para planejamento e capacidade.", [
      "Processo único por evento",
      "Estado em memória",
      "Banco e filas",
      "Pacotes e uploads",
      "Operação offline",
      "Serviços externos",
      "Planejamento de capacidade",
    ]),
    page("server-logs", "Logs e auditoria", "Rastreamento de operações, alertas e privacidade.", [
      "Origens",
      "Níveis",
      "Identificação",
      "ID da operação",
      "Privacidade",
      "Uso operacional",
    ]),
    page("server-diagnosis", "Disponibilidade e diagnóstico", "Caminho para identificar indisponibilidade ou falha de conexão.", [
      "Evento indisponível",
      "Serviço indisponível",
      "Health checks",
      "Banco e processos",
      "Navegador e dispositivo",
      "Informações para suporte",
    ]),
  ], { layout: "reference" }),
  hub("event-management", "Gestão do evento", "Estrutura, inscrições, pessoas, acesso e manutenção.", [
    page("event-product", "Visão comercial do evento", "O evento como unidade central do ecossistema.", [
      "Produtos associados",
      "Público e equipe",
      "Canais de entrada",
      "Conteúdo",
      "Comunicação",
      "Resultados",
    ]),
    page("event-structure", "Criação e estrutura", "Dados e decisões iniciais para montar um evento.", [
      "Criação",
      "Duplicação",
      "Conta responsável",
      "Dados e datas",
      "Fuso horário",
      "Módulos",
      "Teste e produção",
    ]),
    page("event-availability", "Disponibilidade", "Ciclo de vida e efeito de cada status nos produtos.", [
      "Rascunho",
      "Não iniciado",
      "Em andamento",
      "Parado",
      "Encerrado",
      "Automação e reativação",
      "Efeito nos módulos",
    ]),
    page("event-registration", "Inscrições", "Canais, formulário e regras de cadastro.", [
      "Canais de inscrição",
      "Formulário",
      "Validações",
      "Período",
      "Limite",
      "Consentimento",
      "Origem e situação do cadastro",
    ]),
    page("event-import", "Importação de participantes", "Entrada de participantes por planilhas, com validação detalhada e salvamento atômico.", PLATFORM02_IMPORT_GUIDE_SECTIONS),
    page("event-access", "Login e acessos", "Métodos de entrada, links e primeiro acesso.", [
      "Código",
      "Senha",
      "Somente e-mail",
      "Magic link",
      "Convidado",
      "Links",
      "Sessão e tutorial",
    ]),
    page("event-users", "Perfis e participantes", "Papéis, permissões e manutenção da base.", [
      "Participante",
      "Gestor",
      "Expositor",
      "Convidado",
      "Associações",
      "Edição e exportação",
      "Exclusão",
    ]),
    page("event-emails", "E-mails", "Modelos, envios e acompanhamento de entregabilidade.", [
      "Modelos e versões",
      "Registro automático",
      "Envio individual",
      "Lotes e agendamento",
      "Status",
      "Supressões",
      "Reenvio",
    ]),
    page("event-reports", "Relatórios", "Bases operacionais e indicadores do evento.", [
      "Registros",
      "Usuários",
      "Check-ins",
      "Inscrições",
      "Analytics",
      "Transmissões",
      "Exportações",
    ]),
    page("event-maintenance", "Manutenção", "Ações recorrentes durante o ciclo do evento.", [
      "Datas e inscrições",
      "Conteúdos",
      "Participantes",
      "Associações",
      "Alertas",
      "Exportações",
      "Encerramento e exclusão",
    ]),
    page("event-problems", "Problemas frequentes", "Índice de situações que afetam cadastro, acesso e conteúdo.", [
      "Evento não abre",
      "Formulário indisponível",
      "Login",
      "E-mail",
      "Associações",
      "Componentes",
      "Imagens e cache",
    ]),
  ], { layout: "workflow" }),
  hub("customization", "Customização", "Identidade, navegação e apresentação de cada experiência.", [
    page("customization-system", "Como funciona", "Camadas de customização disponíveis no ecossistema.", [
      "Configuração central",
      "Networking",
      "Componentes",
      "Credenciamento",
      "Registro público",
      "Login e PWA",
      "Preview",
    ]),
    page("customization-identity", "Identidade visual", "Elementos que transportam a marca para a plataforma.", [
      "Logos",
      "Ícone",
      "Imagem de compartilhamento",
      "Cores",
      "Fontes",
      "Fundos",
      "Containers e bordas",
    ]),
    page("customization-modes", "Modos de customização", "Personalização simplificada e controles avançados.", [
      "Modo simplificado",
      "Tema claro",
      "Tema escuro",
      "Cor principal",
      "Modo avançado",
      "Substituição do tema",
    ]),
    page("customization-layout", "Layout", "Organização visual dos elementos da interface.", [
      "Fundo",
      "Cabeçalho",
      "Menu",
      "Rodapé",
      "Cards",
      "Modais",
      "Carregamento",
    ]),
    page("customization-pwa", "PWA e metatags", "Instalação, navegador e compartilhamento social.", [
      "Nome e descrição",
      "Favicon",
      "Ícone instalável",
      "Open Graph",
      "Cor do navegador",
      "Instalação",
      "Atualização",
    ]),
    page("customization-home", "Página inicial", "Composição editorial da entrada do aplicativo.", [
      "Apresentação",
      "Banners",
      "Agenda",
      "Transmissões",
      "Atividades",
      "Componentes",
      "Ordem e chamadas",
    ]),
    page("customization-navigation", "Navegação e componentes", "Apresentação e posicionamento das seções.", [
      "Ordem",
      "Título e ícone",
      "Menu",
      "Rodapé",
      "Página inicial",
      "Páginas e links",
      "Permissão da rota",
    ]),
    page("customization-onboarding", "Login e onboarding", "Primeiro contato do público com o evento.", [
      "Tela de login",
      "Boas-vindas",
      "Cadastro",
      "Convidado",
      "Loader",
      "Tutorial",
      "Confirmação de dados",
    ]),
    page("customization-credentialing", "Credenciamento", "Identidade própria da estação e de suas telas.", [
      "Tela da estação",
      "Logo e imagem lateral",
      "Fundo e cores",
      "Check-in",
      "Confirmação",
      "Tela final",
      "QR de cadastro",
    ]),
    page("customization-register", "Registro público", "Apresentação específica do formulário público.", [
      "Logo e layout",
      "Título e instruções",
      "Fundo",
      "Formulário",
      "Rodapé",
      "Conclusão",
      "Inscrições encerradas",
    ]),
    page("customization-practices", "Recomendações visuais", "Critérios para consistência, contraste e responsividade.", [
      "Paleta",
      "Cores neutras",
      "Contraste",
      "Tipografia",
      "Imagens",
      "Mobile e desktop",
      "Validação",
    ]),
  ], { layout: "showcase" }),
  hub("modules", "Módulos", "Produtos e integrações que compõem a Plataforma de eventos.", [
    page("modules-overview", "Visão geral", "Relação entre Networking, Credenciamento e Sympla.", [
      "Produtos",
      "Integrações",
      "Dependências",
      "Dados compartilhados",
      "Customizações independentes",
      "Jornadas combinadas",
    ]),
    networking,
    credentialing,
    sympla,
  ], { layout: "catalog" }),
  hub("operations", "Operação e resultados", "Preparação, acompanhamento, diagnóstico e encerramento.", [
    page("operations-preparation", "Preparação", "Estrutura necessária antes de publicar o evento.", [
      "Responsáveis",
      "Participantes e perfis",
      "Links",
      "Inscrições",
      "Componentes",
      "Equipamentos",
      "Contingência",
    ]),
    page("operations-publish", "Publicação", "Validação final para colocar os canais em funcionamento.", [
      "Status do evento",
      "Módulos",
      "Inscrições",
      "Links",
      "Perfis",
      "Dispositivos",
      "Alertas",
    ]),
    page("operations-day", "Operação do dia", "Acompanhamento das jornadas durante o evento.", [
      "Inscrições",
      "Check-ins",
      "Participantes",
      "Moderação",
      "Transmissões",
      "Comunicados",
      "A&B",
    ]),
    page("operations-monitoring", "Monitoramento", "Sinais para acompanhar saúde técnica e operação.", [
      "Alertas",
      "APIs",
      "Banco e WebSocket",
      "Processos",
      "Logs",
      "E-mails",
      "Integrações e estações",
    ]),
    page("operations-incidents", "Incidentes e suporte", "Padrão de diagnóstico, registro e escalonamento.", [
      "Classificação",
      "Reprodução",
      "Conexão",
      "Sessão",
      "Logs",
      "ID da operação",
      "Escalonamento",
    ]),
    page("operations-closing", "Encerramento", "Fechamento dos módulos e preservação dos resultados.", [
      "Moderação",
      "Competições",
      "Transmissões",
      "Pedidos",
      "Inscrições",
      "Exportações",
      "Encerramento do evento",
    ]),
    page("operations-analytics", "Analytics e interpretação", "Regras para apresentar os números corretamente.", [
      "Participantes",
      "Sessões",
      "Visitantes estimados",
      "Rotas",
      "Push e CTR",
      "Transmissões",
      "Check-ins",
      "Período e fuso",
    ]),
    page("operations-destructive", "Resets e exclusões", "Fronteiras e impactos das ações destrutivas.", [
      "Analytics geral",
      "Relatório de transmissão",
      "Canal",
      "Check-ins",
      "Participantes",
      "Componentes",
      "Evento",
      "Exportação prévia",
    ]),
  ], { layout: "workflow" }),
  page(
    "legacy-guide",
    "Guia antigo",
    "Registro histórico do conteúdo operacional criado anteriormente.",
    [],
    { kind: "legacy", layout: "reference", searchable: false },
  ),
];

export const GUIDE_TRAILS = [
  {
    id: "publish",
    title: "Do zero ao evento publicado",
    description: "Estrutura, personalize e publique a experiência.",
    pages: ["server-architecture", "event-structure", "event-registration", "customization-system", "networking", "networking-components"],
  },
  {
    id: "checkin",
    title: "Do cadastro ao check-in",
    description: "Conecte inscrições, integração, presença e relatório.",
    pages: ["event-registration", "sympla", "credentialing", "credentialing-checkin", "credentialing-print", "credentialing-reports"],
  },
  {
    id: "app",
    title: "Construção do aplicativo",
    description: "Organize navegação, conteúdo e componentes.",
    pages: ["networking", "networking-navigation", "networking-components", "component-schedule", "component-speakers", "operations-publish"],
  },
  {
    id: "incident",
    title: "Diagnóstico de problemas",
    description: "Localize o ponto de falha e prepare o suporte.",
    pages: ["operations-incidents", "event-availability", "server-communication", "server-session", "server-logs", "server-diagnosis"],
  },
];

export const normalizeGuideSearch = (value = "") => value
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, " ")
  .trim();

export const guideSlugify = (value = "") => normalizeGuideSearch(value).replace(/\s+/g, "-");

export const guideHeadingId = (pageId, heading) => `${pageId}-${guideSlugify(heading)}`;

const GUIDE_BASE_HREF = "/ajuda/plataforma-eventos";

const decorateNavigation = (
  nodes,
  parents = [],
  parentHref = GUIDE_BASE_HREF,
  inheritedLayout = "reference",
) => nodes.map((node) => {
  const layout = GUIDE_LAYOUT_OVERRIDES[node.id] || node.layout || inheritedLayout;
  const href = node.id === "home" ? GUIDE_BASE_HREF : `${parentHref}/${node.slug}`;
  const pathItem = {
    id: node.id,
    title: node.title,
    href,
    kind: node.kind,
    layout,
    slug: node.slug,
  };
  const path = [...parents, pathItem];

  return {
    ...node,
    href,
    layout,
    path,
    children: decorateNavigation(node.children || [], path, href, layout),
  };
});

export const GUIDE_NAVIGATION = decorateNavigation(GUIDE_NAVIGATION_SOURCE);

const flattenNavigation = (nodes) => nodes.flatMap((node) => [
  node,
  ...flattenNavigation(node.children || []),
]);

export const GUIDE_PAGES = flattenNavigation(GUIDE_NAVIGATION).map((item) => ({
  ...item,
  searchText: normalizeGuideSearch([
    item.title,
    item.description,
    ...(item.sections || []),
    ...item.path.map((pathItem) => pathItem.title),
  ].join(" ")),
}));

export const GUIDE_PAGE_MAP = GUIDE_PAGES.reduce((result, item) => ({
  ...result,
  [item.id]: item,
}), {});

export const GUIDE_PAGE_BY_HREF = GUIDE_PAGES.reduce((result, item) => ({
  ...result,
  [item.href]: item,
}), {});

export const GUIDE_PILLARS = GUIDE_NAVIGATION.filter(
  (item) => item.id !== "home" && item.id !== "legacy-guide",
);

export const getGuidePageByPath = (pathname = "") => {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return GUIDE_PAGE_BY_HREF[normalizedPath] || null;
};

export const GUIDE_SEARCH_INDEX = GUIDE_PAGES
  .filter((pageItem) => pageItem.searchable !== false)
  .flatMap((pageItem) => {
    const breadcrumb = pageItem.path.map((pathItem) => pathItem.title).join(" / ");
    const pageEntry = {
      id: `page:${pageItem.id}`,
      type: "page",
      title: pageItem.title,
      pageTitle: pageItem.title,
      excerpt: pageItem.description,
      breadcrumb,
      href: pageItem.href,
    };
    const sectionEntries = (pageItem.sections || []).map((section) => ({
      id: `section:${pageItem.id}:${guideSlugify(section)}`,
      type: "section",
      title: section,
      pageTitle: pageItem.title,
      excerpt: pageItem.description,
      breadcrumb,
      href: `${pageItem.href}#${guideHeadingId(pageItem.id, section)}`,
    }));

    return [pageEntry, ...sectionEntries];
  })
  .map((entry) => ({
    ...entry,
    normalizedTitle: normalizeGuideSearch(entry.title),
    normalizedPageTitle: normalizeGuideSearch(entry.pageTitle),
    normalizedExcerpt: normalizeGuideSearch(entry.excerpt),
    normalizedBreadcrumb: normalizeGuideSearch(entry.breadcrumb),
  }));

const scoreSearchEntry = (entry, query, tokens) => {
  const haystack = [
    entry.normalizedTitle,
    entry.normalizedPageTitle,
    entry.normalizedExcerpt,
    entry.normalizedBreadcrumb,
  ].join(" ");

  if (!tokens.every((token) => haystack.includes(token))) return -1;

  let score = entry.type === "section" ? 25 : 0;
  if (entry.normalizedTitle === query) score += 1000;
  else if (entry.normalizedTitle.startsWith(query)) score += 760;
  else if (entry.normalizedTitle.includes(query)) score += 560;

  if (entry.normalizedPageTitle === query) score += 420;
  else if (entry.normalizedPageTitle.includes(query)) score += 260;
  if (entry.normalizedExcerpt.includes(query)) score += 150;
  if (entry.normalizedBreadcrumb.includes(query)) score += 80;

  score += tokens.reduce((total, token) => {
    if (entry.normalizedTitle.startsWith(token)) return total + 60;
    if (entry.normalizedTitle.includes(token)) return total + 35;
    if (entry.normalizedPageTitle.includes(token)) return total + 20;
    return total + 5;
  }, 0);

  return score;
};

export const searchGuidePages = (query, limit = 30) => {
  const normalizedQuery = normalizeGuideSearch(query);
  if (!normalizedQuery) return [];
  const tokens = normalizedQuery.split(/\s+/).filter(Boolean);

  return GUIDE_SEARCH_INDEX
    .map((entry) => ({ ...entry, score: scoreSearchEntry(entry, normalizedQuery, tokens) }))
    .filter((entry) => entry.score >= 0)
    .sort((first, second) => second.score - first.score || first.title.localeCompare(second.title, "pt-BR"))
    .slice(0, limit);
};
